import { axiosInstance } from './baseApi';

const jobTitleApi = {
  getJobTitles: (token, accountId) =>
    axiosInstance({
      method: 'get',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/jobtitle/${accountId}`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }),

  combineJobTitles: (token, accountId, data) =>
    axiosInstance({
      method: 'post',
      url: `${process.env.REACT_APP_CLOUD_API_URL}/jobtitle/combine-jobtitles`,
      headers: {
        Accept: 'application/json',
        Authorization: 'Bearer ' + token,
      },
      data: { ...data, accountId },
    }),
};

export default jobTitleApi; 